import { render, staticRenderFns } from "./assure-consultations.html?vue&type=template&id=3b85966c&scoped=true&external"
import script from "./assure-consultations.js?vue&type=script&lang=js&external"
export * from "./assure-consultations.js?vue&type=script&lang=js&external"
import style0 from "./assure-consultations.scss?vue&type=style&index=0&id=3b85966c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b85966c",
  null
  
)

export default component.exports